import { cn } from '@repo/ui/lib/utils'
import type { LucideIcon } from 'lucide-react'

interface SettingsSidebarItemProps {
  icon: LucideIcon
  label: string
  active: boolean
  onClick: () => void
}

export function SettingsSidebarItem({
  icon: Icon,
  label,
  active,
  onClick,
}: SettingsSidebarItemProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'flex w-full shrink-0 cursor-pointer items-center gap-3 rounded-lg border px-4 py-2.5 text-left text-sm whitespace-nowrap transition-colors',
        active
          ? 'border-primary/30 bg-primary/10 text-foreground'
          : 'border-transparent text-muted-foreground hover:border-border/70 hover:bg-muted/60 hover:text-foreground'
      )}
    >
      <Icon className="h-4 w-4 shrink-0" />
      <span>{label}</span>
    </button>
  )
}
